export default __webpack_public_path__ + "static/media/ic_add.62e4c3d3.svg";